var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWaves(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 134,
    height: 104,
    viewBox: "0 0 134 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M111.929 96.4195C111.443 83.9876 104.287 80.4106 94.04 87.4771C83.7929 94.5436 76.6373 90.9666 76.1509 78.5347C75.6646 66.1028 68.5089 62.5259 58.2619 69.5923C48.0148 76.6588 40.8591 73.0819 40.3728 60.65C39.8864 48.2181 32.7308 44.6411 22.4837 51.7076C12.2366 58.7741 5.08098 55.1971 4.59461 42.7652",
    stroke: "#B68CB8",
    strokeWidth: 3.52741,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M120.801 78.6926C120.314 66.2607 113.159 62.6837 102.912 69.7502C92.6645 76.8167 85.5089 73.2397 85.0225 60.8078C84.5361 48.3759 77.3805 44.7989 67.1334 51.8654C56.8863 58.9319 49.7307 55.3549 49.2443 42.923C48.758 30.4911 41.6023 26.9142 31.3552 33.9806C21.1082 41.0471 13.9525 37.4702 13.4662 25.0383",
    stroke: "#B68CB8",
    strokeWidth: 3.52741,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M129.676 60.9671C129.189 48.5352 122.034 44.9582 111.787 52.0247C101.54 59.0912 94.3839 55.5142 93.8975 43.0823C93.4111 30.6504 86.2555 27.0735 76.0084 34.14C65.7613 41.2064 58.6057 37.6295 58.1193 25.1976C57.633 12.7657 50.4773 9.1887 40.2302 16.2552C29.9832 23.3217 22.8275 19.7447 22.3412 7.3128",
    stroke: "#B68CB8",
    strokeWidth: 3.52741,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaves);
export default __webpack_public_path__ + "static/media/waves.89ce8377d586554f0b6c046a7d990c1c.svg";
export { ForwardRef as ReactComponent };